__turbopack_context__.v({
  "background": "login-module__B8jGpa__background",
  "brand": "login-module__B8jGpa__brand",
  "image": "login-module__B8jGpa__image",
  "login-shake": "login-module__B8jGpa__login-shake",
  "shake": "login-module__B8jGpa__shake",
  "shell": "login-module__B8jGpa__shell",
});
